module.exports = {
  SET_PRACTICE_FROM_SUBDOMAIN_REQUEST: 'SET_PRACTICE_FROM_SUBDOMAIN_REQUEST',
  SET_PRACTICE_FROM_SUBDOMAIN_SUCCESS: 'SET_PRACTICE_FROM_SUBDOMAIN_SUCCESS',
  SET_PRACTICE_FROM_SUBDOMAIN_FAILURE: 'SET_PRACTICE_FROM_SUBDOMAIN_FAILURE',
}



// WEBPACK FOOTER //
// ./src/common/modules/practice/constants.js